namespace TabAurous.HR {
    export interface PayrollDetailsRow {
        DetailId?: number;
        TransId?: number;
        EmployeeId?: number;
        EmployeeName?: string;
        EmployeeCode?: string;
        DepartmentId?: number;
        DesignationId?: number;
        CompanyId?: number;
        NetSalary?: number;
        GrossSalary?: number;
        TaxAmount?: number;
        DesignationName?: string;
        DeptName?: string;
        CompanyName?: string;
        Present?: number;
        Absent?: number;
        HalfDay?: number;
        OnLeave?: number;
        EmployeeDetails?: PayrollEmployeeDetailsRow[];
        Earnings?: PayrollEmployeeDetailsRow[];
        Deductions?: PayrollEmployeeDetailsRow[];
    }

    export namespace PayrollDetailsRow {
        export const idProperty = 'DetailId';
        export const localTextPrefix = 'HR.PayrollDetails';
        export const deletePermission = 'HR:Payroll:Delete';
        export const insertPermission = 'HR:Payroll:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:Payroll:Edit';

        export declare const enum Fields {
            DetailId = "DetailId",
            TransId = "TransId",
            EmployeeId = "EmployeeId",
            EmployeeName = "EmployeeName",
            EmployeeCode = "EmployeeCode",
            DepartmentId = "DepartmentId",
            DesignationId = "DesignationId",
            CompanyId = "CompanyId",
            NetSalary = "NetSalary",
            GrossSalary = "GrossSalary",
            TaxAmount = "TaxAmount",
            DesignationName = "DesignationName",
            DeptName = "DeptName",
            CompanyName = "CompanyName",
            Present = "Present",
            Absent = "Absent",
            HalfDay = "HalfDay",
            OnLeave = "OnLeave",
            EmployeeDetails = "EmployeeDetails",
            Earnings = "Earnings",
            Deductions = "Deductions"
        }
    }
}
